import {GetColumnValueFuncI, PrimitiveObject, RefCondition} from "../Types";
import styled from "styled-components";
import React from "react";
import CopyButton from "./misc/CopyButton";
import moment from "moment";
import ImageViewer from "./misc/ImageViewer";
import {functions} from "../config";
import {faCheck, faXmark} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {GREEN_COLOR, ICONS, RED_COLOR} from "./CONSTANTS";
import hljs from "highlight.js/lib/core";
import RefValueUI, {createRefKey, refConditionToFilters} from "./table/refType/RefValueUI";
import RefConditionValue from "./table/refType/RefConditionValue";

export const getColumnValue: GetColumnValueFuncI = (value, schema, forHeader = false, record = null) => {

    if (schema.type === 'ref') {
        if (schema.applyTransform && schema.getColumnValue !== undefined)
            return 'REF CANNOT HAVE CUSTOM TRANSFORMATION! ONLY PER EACH INDIVIDUAL PROP MODIFICATION'

        if (!schema.ref)
            return 'NO REF!'
        if (!record)
            return 'NO RECORD FOR REF!'

        const filters = refConditionToFilters(schema.ref.condition, record)
        const refKey = createRefKey(filters, schema.ref.limit, schema.ref.order);

        if (value === true)
            return <RefConditionValue filters={filters} fieldSchema={schema as any} refKey={refKey}/>

        return <RefValueUI fieldSchema={schema as any} refKey={refKey} filters={filters} record={record}/>
    }

    if (schema.applyTransform && schema.getColumnValue !== undefined) {
        return functions[schema.getColumnValue].apply(null, [value, schema, forHeader, record])
    }


    const nullColumn = <div className={forHeader ? 'text-align-center' : ''}>{forHeader ? "" :
        <i className={"null-value"}>NULL</i>}</div>;

    if (value === null)
        return nullColumn
    if (value === undefined) {
        return <div className={forHeader ? 'text-align-center' : ''} style={{color: 'yellow'}}><i>Value is missing</i>
        </div>;
    }

    if (!schema.applyTransform)
        return value

    if (schema.type === 'number' && forHeader)
        return <div className={'text-align-center'}>{value}</div>;
    if (schema.type === 'boolean') {
        let v = value ? 'Так' : 'Ні' as any
        if (forHeader)
            v = <FontAwesomeIcon title={value ? 'Так' : 'Ні'} icon={value ? faCheck : faXmark}
                                 style={{width: '1rem', height: '1rem'}}
                                 className={'fa-color-bool'}/>
        return <BoolContainer $forHeader={forHeader} $checked={value}>
            {v}
        </BoolContainer>;
    }
    if (schema.type === 'url')
        return <Link target={'_blank'} href={value}>{value}</Link>
    if (schema.type === 'tel') {
        // const v = value.startsWith('+') ? value : '+' + value;
        return <PhoneCol $monospace={false} $center={false}>{value}<CopyButton copyValue={value}/></PhoneCol>
    }
    if (schema.type === 'email') {
        return <PhoneCol>{value}<CopyButton copyValue={value}/></PhoneCol>
    }
    if (schema.type === 'json' && !forHeader) {
        let html = ''
        try {
            let v = JSON.stringify(JSON.parse(value), null, 2)
            html = hljs.highlight(v, {language: 'json'}).value;
        } catch (e) {
            html = hljs.highlight(value, {language: 'json'}).value;
        }
        return <pre style={{width: '100%', height: schema.jsonHeight + 'px' || '500px', maxWidth: '1000px'}}><code
            style={{overflow: 'auto', height: schema.jsonHeight + 'px' || '500px'}}
            dangerouslySetInnerHTML={{__html: html}}
            className={'language-json hljs'}></code></pre>
    }
    if (schema.type === 'image') {
        if (forHeader)
            return value
        return <ImageCol>
            <ImageViewer src={value} maxHeightProp={schema.imageMaxHeight || 500}
                         maxWidthProp={schema.imageMaxWidth || 400}/>
            <hr/>
            <Link target={'_blank'} href={value}>{value}</Link>
        </ImageCol>
    }
    if (schema.type === 'map') {
        let mapValue = schema.map?.values?.[value];
        //TODO CREATE COMPONENT TO DOWNLOAD NEEDED MAP BY SEARCHING NEEDED ONE VIA STATE
        let v = mapValue?.lang['ua'] || <i>Завантажте значення у рідній таблиці</i>
        let icon = mapValue?.icon;
        if (forHeader && icon && ICONS[icon]) {
            return <div className={'text-align-center'} style={{color: mapValue?.color}}>
                <FontAwesomeIcon icon={ICONS[icon]} title={mapValue!.rawValue as string}
                                 style={{width: '1.2rem', height: '1.2rem'}}/>
            </div>
        }
        return <div style={{backgroundColor: schema.map?.backgroundColor, color: mapValue?.color}}
                    className={'map-colored-value'}>{v}</div>;
    }
    if (schema.type === 'datetime' || schema.type === 'date' || schema.type === 'time') {
        if (schema.type === 'time')
            return <div
                className={forHeader ? 'text-align-center' : ''}>{moment(value, [moment.ISO_8601, schema.datetimeFormat ?? 'HH:mm'])
                .format(schema.datetimeFormat)}</div>;
        return moment(value).format(schema.datetimeFormat);
    }

    return value;
}

const PhoneCol = styled.div<any>`
    display: inline-flex;
    //align-items: center;
    justify-content: ${props => props.$center ? 'center' : 'left'};
    ${props => props.$monospace && 'font-family: monospace;'};
    width: 100%;
    gap: .4rem;
    white-space: nowrap; /* Prevents wrapping */
    flex-grow: 0;
    flex-shrink: 1;

    font-size: 1rem;

    & > img {
        flex-shrink: 0;
        min-width: 1.5rem;
        min-height: 1.5rem;
    }

    & span {
        //vertical-align: middle;
    }

    //vertical-align: middle;

`


const BoolContainer = styled.div<any>`
    justify-content: center;
    display: ${props => props.$forHeader ? 'inline-flex' : 'block'};
    width: ${props => props.$forHeader ? '100%' : 'auto'};

    & .fa-color-bool {
        path {
            fill: ${props => props.$checked ? GREEN_COLOR : RED_COLOR};
            stroke: ${props => props.$checked ? GREEN_COLOR : RED_COLOR};
        }
    }

    //& div {
    //    width: 2rem;
    //    padding: 0 .2rem;
    //    text-align: center;
    //    background-color: #3b3939;
    //}
`

export const Link = styled.a`
    color: var(--table-action-color);

    &:after {
        content: ' ⭷';
        color: var(--table-row-text-color);
    }

    &:visited {
        color: lightpink;
    }
`

const ImageCol = styled.div<any>`
    //display: inline-flex;
    //flex-flow: column;
    justify-content: left;
    width: 100%;
    gap: .4rem;

    & hr {
        background-color: var(--table-action-color);
        height: 2px;
        width: 100%;
        margin: .2rem 0;
    }

    //& > img {
    //    flex-shrink: 0;
    //    width: 100%;
    //    height: auto;
    //}

    & span {
        vertical-align: middle;
    }

    vertical-align: middle;

`
